import React, {useState} from 'react';
import styled from 'styled-components';
import { Container, Form, Button, ToggleButtonGroup, ToggleButton, Row, Modal } from 'react-bootstrap';

import { Col } from 'react-bootstrap';


const Styles = styled.div`
    .overlay {
        position: absolute;
        top: 10px;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: -1;
    }
`;

export class DomainOfRooms extends React.Component {

    state = { modalShow: null, setModalShow: null};


    constructor(props) {
        super(props);
        
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.updateState = this.updateState.bind(this);
    }

    onChange(e) {
      this.setState({[e.target.name]: e.target.value});
  }

  onSubmit(e) {
      e.preventDefault();

      const domain_of_rooms = {
        id: 1,
        precent: document.getElementById("precent").value ,
        bariatric: document.getElementById("bariatric").value,
        appendectomy: document.getElementById("appendectomy").value,
        liver_transplant: document.getElementById("liver_transplant").value,
        other: document.getElementById("other").other
      };
      console.log(domain_of_rooms)
    //   updatePriority(priority).then(res => {
    //     if (res) {
    //       window.location.reload();
    //     }
    //     else {
            
    //     }
    // })
    
  
  }

  

    updateState = state => {
        this.setState({ selectedRows: state.selectedRows });
      }

      addSpecificDomain = () => {
      
        this.setState({EventModalShow: true});
      }


  render() {


    function MyVerticallyCenteredModal(props) {

        function onSubmitModal(e) {
            e.preventDefault();
        
            const domain_of_rooms = {
              id: 1,
              precent: document.getElementById("precent").value ,
              bariatric: document.getElementById("bariatric").value,
              appendectomy: document.getElementById("appendectomy").value,
              liver_transplant: document.getElementById("liver_transplant").value,
              other: document.getElementById("other").other
            };
            console.log(domain_of_rooms)
        }

        const [domain, setDomain] = useState([1]);
        const [room, setRoom] = useState('');

        return (
            
          <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">
                Specific Room for a Specific Domain
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <div>
            <Form onSubmit={onSubmitModal}>
                <h4>Room:</h4>
                    <Form.Group controlId="room" name="room" value={room} onChange={event => {setRoom(event.target.value); console.log(event.target.value)}}>
                        <Form.Control as ="select">
                            <option>1</option>
                            <option>2</option>
                            <option>3</option>
                            <option>4</option>
                        </Form.Control>
                    </Form.Group>
                <h4>Domain:</h4>
                    <ToggleButtonGroup name="domain" type="checkbox" value={domain} onChange={val => {setDomain(val); console.log(val)}}>
                        <ToggleButton value={1}>Bariatric</ToggleButton>
                        <ToggleButton value={2}>Appendectomy</ToggleButton>
                        <ToggleButton value={3}>Liver Transplant</ToggleButton>
                        <ToggleButton value={4}>Other</ToggleButton>
                    </ToggleButtonGroup>
                    </Form>
                    </div>  
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={onSubmitModal}>Submit</Button>
              <Button variant="danger" onClick={props.onHide}>Close</Button>
            </Modal.Footer>
          </Modal>
        );
      }

      let EventModalClose = () => this.setState({EventModalShow: false, info: null});

    return (
      <Styles>
              <div className="overlay"></div>
                <Container>
                    <Form onSubmit={this.onSubmit}>
                         <Form.Row>
                         <Form.Group controlId="precent">
                            <Form.Label>How much percent of the total amount of operating rooms should beallocated for future scheduled?</Form.Label>
                            <Form.Control as="select">
                                <option>{null}</option>
                                <option>20%</option>
                                <option>40%</option>
                                <option>60%</option>
                                <option>80%</option>
                            </Form.Control>
                            </Form.Group>
                            </Form.Row>
                            <Form.Row>
                            <p>How many rooms (in a week) do you want to assigned for each of the following domains:</p>   
                            </Form.Row> 
                            <Form.Row>
                            <Form.Group as={Col} controlId="bariatric">
                            <Form.Label>Bariatric:</Form.Label>
                            <Form.Control type="number" min="0"/>
                        </Form.Group>     
                        <Form.Group as={Col} controlId="appendectomy">
                            <Form.Label>Appendectomy:</Form.Label>
                            <Form.Control type="number" min="0"/>
                        </Form.Group>  
                        <Form.Group as={Col} controlId="liver_transplant">
                            <Form.Label>Liver Transplant:</Form.Label>
                            <Form.Control type="number" min="0"/>
                        </Form.Group>  
                        <Form.Group as={Col} controlId="other">
                            <Form.Label>Other:</Form.Label>
                            <Form.Control type="number" min="0"/>
                        </Form.Group> 
                        </Form.Row> 
                        <Form.Row>
                        
                        </Form.Row>
                        <Button variant="primary" type="submit">
                            Save Domain of Rooms
                        </Button>
                        <Row>
                            <br></br>
                        </Row>
                        <Row>
                            <Col>
                                <Button variant="danger" type="submit" onClick={this.addSpecificDomain}>
                                Select a Specific Domain for a Specific Room
                                </Button>
                            </Col>
                        </Row>
                         
                    </Form>
                </Container>

                <MyVerticallyCenteredModal
                show={this.state.EventModalShow}
                onHide={EventModalClose}
                currinfo ={this.state.info}
            />
      </Styles>
    )
  }
};
 
export default DomainOfRooms
